import { render, staticRenderFns } from "./MonthTask.vue?vue&type=template&id=473d3132&"
import script from "./MonthTask.vue?vue&type=script&lang=js&"
export * from "./MonthTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports